var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSolarCalendarMarkBoldDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22 14V12C22 11.161 21.987 9.665 21.974 9H2.006C1.993 9.665 2.006 11.161 2.006 12V14C2.006 17.771 2.006 19.657 3.176 20.828C4.349 22 6.234 22 10.004 22H14.004C17.774 22 19.658 22 20.83 20.828C22 19.657 22 17.771 22 14Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96 2C7.378 2 7.716 2.31 7.716 2.692V4.09C8.386 4.078 9.138 4.078 9.984 4.078H14.016C14.862 4.078 15.613 4.078 16.284 4.09V2.692C16.284 2.31 16.622 2 17.04 2C17.458 2 17.796 2.31 17.796 2.692V4.15C19.246 4.256 20.199 4.518 20.899 5.158C21.599 5.799 21.884 6.671 22 8V9H2V8C2.116 6.671 2.401 5.8 3.101 5.158C3.801 4.518 4.753 4.256 6.204 4.15V2.692C6.204 2.31 6.543 2 6.96 2Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5C18 16.8978 17.842 17.2794 17.5607 17.5607C17.2794 17.842 16.8978 18 16.5 18C16.1022 18 15.7206 17.842 15.4393 17.5607C15.158 17.2794 15 16.8978 15 16.5C15 16.1022 15.158 15.7206 15.4393 15.4393C15.7206 15.158 16.1022 15 16.5 15C16.8978 15 17.2794 15.158 17.5607 15.4393C17.842 15.7206 18 16.1022 18 16.5Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSolarCalendarMarkBoldDuotone);
export default __webpack_public_path__ + "static/media/ic-solar_calendar-mark-bold-duotone.0f874763cce641517404d3be29da324c.svg";
export { ForwardRef as ReactComponent };